/* eslint-disable indent */
import { useEffect, useState, useRef } from 'preact/hooks';
import { html } from 'htm/preact';
import Fuse from 'fuse.js';
import { get } from '../../utilities/fetch';

export default function ServicelocationFetcher() {
  const [servicelocations, setServicelocations] = useState([]);
  const [formData, setformData] = useState({
    titleSearch: '',
    order: 'asc',
    show: 10,
  });
  const [fuse, setFuse] = useState(null);
  const [filteredServicelocations, setFilteredServicelocations] = useState([]);
  const [selectedServicelocation, setSelectedServicelocation] = useState(null);
  const root = useRef(null);

  function getServicelocationIdFromUrl(servicelocationlist = []) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const servicelocationid = urlParams.get('servicelocationid');
    const servicelocation = servicelocationlist
      .find((servicelocationItem) => servicelocationItem.id == servicelocationid);
    setSelectedServicelocation(servicelocation);
  }

  async function fetchServicelocations() {
    try {
      const result = await get('/wp-json/ppshp/v1/servicelocations');

      setServicelocations(result.servicelocations);
      setFilteredServicelocations(result.servicelocations);
      setFuse(new Fuse(result.servicelocations, { keys: ['title'], threshold: 0.3 }));
      getServicelocationIdFromUrl(result.servicelocations);
    } catch (err) {
      // TODO: Error.
    // eslint-disable-next-line no-empty
    } finally {
    }
  }

  useEffect(() => {
    fetchServicelocations();
  }, []);

  function selectServicelocation(servicelocation) {
    document.querySelector('.page__breadcrumbs').style.display = 'none';
    const url = new URL(window.location);
    url.searchParams.set('servicelocationid', servicelocation.id);
    window.history.replaceState({}, '', url);
    setSelectedServicelocation(servicelocation);
  }

  function loopServicelocations() {
    return filteredServicelocations.map((servicelocation, index) => {
      const hideClass = formData.show < index + 1 ? 'display-none' : '';
      return html`
        <li class="${hideClass}" onClick=${() => { selectServicelocation(servicelocation); }}>
          <header><a href="#"></a>${servicelocation.title}</header>
        </li>
      `;
    });
  }

  function compare(a, b, order = 'asc') {
    if (a.title < b.title) {
      return order === 'asc' ? -1 : 1;
    }
    if (a.title > b.title) {
      return order === 'asc' ? 1 : -1;
    }
    return 0;
  }

  function runFilters(titleSearch = '', order = 'asc') {
    // Text search utilizing Fuse.js fuzzy search.
    let filteredLocations = [...servicelocations];
    filteredLocations.sort((a, b) => compare(a, b, order));
    filteredLocations = (titleSearch === '')
      ? filteredLocations
      : fuse.search(titleSearch).map((r) => r.item);
    setFilteredServicelocations(filteredLocations);
  }

  function onTextFormSubmit(e) {
    e.preventDefault();

    const textFormData = new FormData(e.target);
    setformData({
      ...formData,
      titleSearch: textFormData.get('title_search'),
    });
    // this.filters.searchTerm = formData.get('search_term');
    runFilters(textFormData.get('title_search'), formData.order);
  }

  function onSelectChange(e) {
    setformData({
      ...formData,
      order: e.target.value,
    });
    runFilters(formData.titleSearch, e.target.value);
  }

  function unselectServicelocation(e) {
    e.preventDefault();
    document.querySelector('.page__breadcrumbs').style.display = 'block';
    const url = new URL(window.location);
    url.searchParams.delete('servicelocationid');
    window.history.replaceState({}, '', url);
    setSelectedServicelocation(null);
  }

  function showMoreServicelocations() {
    setformData({
      ...formData,
      show: 1000,
    });
    runFilters(formData.titleSearch, formData.order);
  }

  function loopPhonenumbers(phonenumbers = []) {
    if (!phonenumbers) {
      return null;
    }
    return html`<h3>Puhelinnumerot</h3>
    ${phonenumbers.map((phonenumber) => html`
        <div>
          ${phonenumber.short_desc === '' ? null : html`<h4>${phonenumber.short_desc}</h4>`}
          <p>${phonenumber.phonenumber}</p>
          ${(phonenumber.service_hours_monday || phonenumber.service_hours_tuesday || phonenumber.service_hours_wednesday || phonenumber.service_hours_thursday || phonenumber.service_hours_friday || phonenumber.service_hours_saturday || phonenumber.service_hours_sunday) ? html`
          <div class="servicelocations_dropdown">
            <button class="servicelocations_dropdown-btn">Soittoajat</button>
            <div class="servicelocations_dropdown-content">
              <div class="servicelocation-table"><div class="servicelocations_info"><span class="span-width">Maanantai</span><span>${phonenumber.service_hours_monday ? phonenumber.service_hours_monday : html`-`}</span></div></div>
              <div class="servicelocation-table"><div class="servicelocations_info"><span class="span-width">Tiistai</span><span>${phonenumber.service_hours_tuesday ? phonenumber.service_hours_tuesday : html`-`}</span></div></div>
              <div class="servicelocation-table"><div class="servicelocations_info"><span class="span-width">Keskiviikko</span><span>${phonenumber.service_hours_wednesday ? phonenumber.service_hours_wednesday : html`-`}</span></div></div>
              <div class="servicelocation-table"><div class="servicelocations_info"><span class="span-width">Torstai</span><span>${phonenumber.service_hours_thursday ? phonenumber.service_hours_thursday : html`-`}</span></div></div>
              <div class="servicelocation-table"><div class="servicelocations_info"><span class="span-width">Perjantai</span><span>${phonenumber.service_hours_friday ? phonenumber.service_hours_friday : html`-`}</span></div></div>
              <div class="servicelocation-table"><div class="servicelocations_info"><span class="span-width">Lauantai</span><span>${phonenumber.service_hours_saturday ? phonenumber.service_hours_saturday : html`-`}</span></div></div>
              <div class="servicelocation-table"><div class="servicelocations_info"><span class="span-width">Sunnuntai</span><span>${phonenumber.service_hours_sunday ? phonenumber.service_hours_sunday : html`-`}</span></div></div>
            </div>
          </div>` : null}
        </div>
      `)}
    `;
  }

  function singleServicelocationContainer() {
    return html`
      <div class="servicelocation-results-container">
        <div class="back_btn">
          <a onClick=${unselectServicelocation} href="#"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
            <path fill="var(--colors-link)" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z "/>
          </svg>Takaisin hakuun</a>
        </div>
        <h2>${selectedServicelocation.title}</h2>
        <h3>Käyntiosoite</h3>
        <p>${selectedServicelocation.acf.address_street_name} ${selectedServicelocation.acf.address_street_number} ${selectedServicelocation.acf.address_postalcode} ${selectedServicelocation.acf.address_city} </p>
        <h3>Opastustiedot</h3>
          <div class="servicelocation-table"><span class="span-width">Sisäänkäynti</span><span>${selectedServicelocation.acf.entrance}</span></div>
          <div class="servicelocation-table"><span class="span-width">Rakennuksen osa</span><span>${selectedServicelocation.acf.building_part}</span></div>
          <div class="servicelocation-table"><span class="span-width">Kerros</span><span>${selectedServicelocation.acf.floor}</span></div>
        <h3>Aukioloajat</h3>
          ${(selectedServicelocation.acf.service_hours_monday || selectedServicelocation.acf.service_hours_tuesday || selectedServicelocation.acf.visiting_hours_wednesday || selectedServicelocation.acf.service_hours_thursday || selectedServicelocation.acf.service_hours_friday
            || selectedServicelocation.acf.service_hours_friday || selectedServicelocation.acf.service_hours_saturday || selectedServicelocation.acf.service_hours_sunday) ? html`
          <div class="servicelocation-table"><span class="span-width">Maanantai</span><span>${selectedServicelocation.acf.service_hours_monday ? selectedServicelocation.acf.service_hours_monday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Tiistai</span><span>${selectedServicelocation.acf.service_hours_tuesday ? selectedServicelocation.acf.service_hours_tuesday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Keskiviikko</span><span>${selectedServicelocation.acf.service_hours_wednesday ? selectedServicelocation.acf.service_hours_wednesday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Torstai</span><span>${selectedServicelocation.acf.service_hours_thursday ? selectedServicelocation.acf.service_hours_thursday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Perjantai</span><span>${selectedServicelocation.acf.service_hours_friday ? selectedServicelocation.acf.service_hours_friday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Lauantai</span><span>${selectedServicelocation.acf.service_hours_saturday ? selectedServicelocation.acf.service_hours_saturday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Sunnuntai</span><span>${selectedServicelocation.acf.service_hours_sunday ? selectedServicelocation.acf.service_hours_sunday : html`-`}</span></div>` : html`<p>Ei tietoja</p>`}
          ${loopPhonenumbers(selectedServicelocation.acf.phonenumbers)}
        <h3>Vierailuajat</h3>
      ${selectedServicelocation.acf.visiting_hours_monday || selectedServicelocation.acf.visiting_hours_tuesday || selectedServicelocation.acf.visiting_hours_wednesday || selectedServicelocation.acf.visiting_hours_thursday || selectedServicelocation.acf.visiting_hours_friday
      || selectedServicelocation.acf.visiting_hours_friday || selectedServicelocation.acf.visiting_hours_saturday || selectedServicelocation.acf.visiting_hours_sunday ? html`
        <div class="servicelocation-table"><span class="span-width">Maanantai</span><span>${selectedServicelocation.acf.visiting_hours_monday ? selectedServicelocation.acf.visiting_hours_monday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Tiistai</span><span>${selectedServicelocation.acf.visiting_hours_tuesday ? selectedServicelocation.acf.visiting_hours_tuesday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Keskiviikko</span><span>${selectedServicelocation.acf.visiting_hours_wednesday ? selectedServicelocation.acf.visiting_hours_wednesday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Torstai</span><span>${selectedServicelocation.acf.visiting_hours_thursday ? selectedServicelocation.acf.visiting_hours_thursday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Perjantai</span><span>${selectedServicelocation.acf.visiting_hours_friday ? selectedServicelocation.acf.visiting_hours_friday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Lauantai</span><span>${selectedServicelocation.acf.visiting_hours_saturday ? selectedServicelocation.acf.visiting_hours_saturday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Sunnuntai</span><span>${selectedServicelocation.acf.visiting_hours_sunday ? selectedServicelocation.acf.visiting_hours_sunday : html`-`}</span></div>` : html`<p>Ei tietoja</p>`}
        <h3>Päivystysajat</h3>
      ${selectedServicelocation.acf.on_call_hours_monday || selectedServicelocation.acf.on_call_hours_tuesday || selectedServicelocation.acf.on_call_hours_wednesday || selectedServicelocation.acf.on_call_hours_thursday || selectedServicelocation.acf.on_call_hours_friday
      || selectedServicelocation.acf.on_call_hours_friday || selectedServicelocation.acf.on_call_hours_saturday || selectedServicelocation.acf.on_call_hours_sunday ? html`
        <div class="servicelocation-table"><span class="span-width">Maanantai</span><span>${selectedServicelocation.acf.on_call_hours_monday ? selectedServicelocation.acf.on_call_hours_monday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Tiistai</span><span>${selectedServicelocation.acf.on_call_hours_tuesday ? selectedServicelocation.acf.on_call_hours_tuesday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Keskiviikko</span><span>${selectedServicelocation.acf.on_call_hours_wednesday ? selectedServicelocation.acf.on_call_hours_wednesday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Torstai</span><span>${selectedServicelocation.acf.on_call_hours_thursday ? selectedServicelocation.acf.on_call_hours_thursday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Perjantai</span><span>${selectedServicelocation.acf.on_call_hours_friday ? selectedServicelocation.acf.on_call_hours_friday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Lauantai</span><span>${selectedServicelocation.acf.on_call_hours_saturday ? selectedServicelocation.acf.on_call_hours_saturday : html`-`}</span></div>
          <div class="servicelocation-table"><span class="span-width">Sunnuntai</span><span>${selectedServicelocation.acf.on_call_hours_sunday ? selectedServicelocation.acf.on_call_hours_sunday : html`-`}</span></div>` : html`<p>Ei tietoja</p>`}
    </div>
    `;
  }

  function servicelocationSearchContainer() {
    return html`
    <div class="location-search-top">
      <h1>Opastuspalvelu</h1>
      <p class="lead">Hae palvelupisteitä</p>
      <form onSubmit=${onTextFormSubmit} class="location-search-form">
        <label class="screen-reader-text" for="search_location-identifier">Sanahaku</label>
        <div class="location-search-form__search">
          <input name="title_search" id="search_location-identifier" class="location-search-form__input" type="text" placeholder="Sanahaku" />
          <button class="location-search-form__button">Hae
          <span class="icon  icon--on-right">
            <svg fill="var(--colors-white)" focusable="false" viewBox="0 0 24 24" height="24" width="24"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path></svg>
          </span></button>
        </div>
      </form>
    </div>
      <div class="lead location-search-result-count">
        Löytyi ${filteredServicelocations.length} hakutulosta
      </div>
    <div class="location-search-order">
      <div class="input-row">
        <label class="screen-reader-text" for="order-identifier">Järjestä</label>
        <div class="select">
          <select onChange=${onSelectChange} id="order-identifier">
            <option value="asc">Järjestä aakkosjärjestykseen A - Ö</option>
            <option value="desc">Järjestä aakkosjärjestykseen Ö - A</option>
          </select>
          <span class="icon"></span>
        </div>
      </div>
    </div>
    <div class="location-search-results">
      <ul>
        ${loopServicelocations()}
      </ul>
    </div>
    ${formData.show === 1000 ? null : html`<button class="button" onClick=${showMoreServicelocations}>Näytä enemmän</button>`}
    `;
  }

  function locationSearchContent() {
    if (selectedServicelocation) {
      return singleServicelocationContainer();
    }
    return servicelocationSearchContainer();
  }

  return html`

  <div class="location-search-container" ref=${root}>
    ${locationSearchContent()}
  </div>
  `;
}
